import React from 'react';

// The result of a file import, shown in full on the page. A browser alert
// cuts long text off (for example a long list of rows in a reconciled month).
export default function ImportNotice({ text, onClose }) {
  if (!text) return null;
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="import-notice-title"
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div className="bg-white rounded shadow-lg p-4" style={{ maxWidth: 640, width: '100%' }}>
        <h2 id="import-notice-title" className="text-lg font-semibold mb-2">Import result</h2>
        <div data-testid="import-notice-text" className="text-sm"
          style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: '60vh', overflowY: 'auto' }}>{text}</div>
        <div className="mt-3 text-right">
          <button type="button" onClick={onClose} className="px-3 py-1 bg-blue-600 text-white rounded">OK</button>
        </div>
      </div>
    </div>
  );
}
